import React from 'react';

import Heading from 'Components/Heading/Heading';
import TeamSJ from '../../Assets/elvotaimages/team_SJ.jpeg';
import TeamOL from '../../Assets/elvotaimages/team_OL.jpeg';

import TeamCard from './TeamCard';

export default function Team() {
  const contentValues = [
    {
      name: 'Stanislas Jouven',
      position: 'Co-founder, CEO',
      addtionalText: [
        'Stanislas graduated from EPFL with a Master in Data Science. He co-founded Evolta Technologies to revolutionise energy storage optimisation using AI and deep learning.',
        'Leveraging over 20 years of family experience in the renewable energy industry, Stanislas combines his technical skills with an innate understanding of the energy market.',
        'His background makes him a key player in ensuring Evolta Technologies’s success in transforming battery energy storage systems.',
      ],
      imageSrc: TeamSJ,
      linkedinLink: 'https://www.linkedin.com/in/stanislas-jouven/',
    },
    {
      name: 'Olivier Lam',
      position: 'Co-founder, COO',
      addtionalText: [
        'Olivier holds a Master in Data Science from EPFL and is an experienced entrepreneur specialising in AI-driven time-series forecasting. His background includes working at an EPFL spin-off (VisualStructure), where he developed models for predicting a variety of signals and building tools for options trading.',
        'Now, as co-founder of Evolta Technologies, Olivier brings his deep expertise in data modelling and machine learning to optimise energy dispatch for BESS, ensuring efficient and profitable battery operations.',
      ],
      imageSrc: TeamOL,
      linkedinLink: 'https://www.linkedin.com/in/olivier-qv-lam/',
    },
  ];
  return (
    <div>
      <Heading content="Team" />
      <div className="grid grid-cols-12">
        {contentValues.map(
          (
            value,
            index // Use map to render elements
          ) => (
            <>
              {index === 1 && <div className="col-span-1" />}
              <div
                className="col-span-12 sm:col-span-5 xs:col-span-12 mb-4"
                key={value.imageSrc || index}
              >
                <TeamCard
                  name={value.name}
                  position={value.position}
                  additionalText={value.addtionalText}
                  imageSrc={value.imageSrc}
                  linkedinLink={value.linkedinLink}
                />
              </div>{' '}
            </>
          )
        )}
      </div>
    </div>
  );
}
